<!-- eslint-disable vue/no-unused-vars -->
<template>
	<div class="my-3">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form>
				<b-row>
					<b-col md="8" cols="12">
						<b-form-group label="Total Rental Income (Monthly)">
							<b-form-input v-model="totalRentalIncome" type="text" placeholder="Enter Total Rental Income (Monthly)"
								disabled></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<el-table :data="rentals" style="width: 100%" cell-class-name="px-3">
					<el-table-column label="No." width="50" align="center">
						<template slot-scope="scope">{{ scope.$index + 1 }}</template>
					</el-table-column>
					<el-table-column label="Rental Income Amount" min-width="200">
						<template slot-scope="scope">
							<CurrencyInput v-model="scope.row.amount"
								:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
						</template>
					</el-table-column>
					<el-table-column label="Postal Code" min-width="120">
						<template slot-scope="scope">
							<ValidationProvider v-slot="{ errors }" :rules="{ postcode: true }" :vid="'postcode'">
								<b-form-input v-model="scope.row.postcode" @keydown="_gHlp.checkNonNumericInput" type="text"
									maxlength="5"></b-form-input>
								<small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
							</ValidationProvider>
						</template>
					</el-table-column>
					<el-table-column label="Housing Type" min-width="200">
						<template slot-scope="scope">
							<el-select v-model="scope.row.housing_type_id" placeholder="Select">
								<el-option v-for="housingType in tables.housing_types" :key="housingType.housing_type_id"
									:label="housingType.type" :value="housingType.housing_type_id">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="Project Name" min-width="250">
						<template slot-scope="scope">
							<el-input v-model="scope.row.project_name"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Actions" min-width="100">
						<template slot-scope="scope">
							<svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeRental(scope.row)"
								class="text-danger cursor-pointer mx-2" width="20" height="20" viewBox="0 0 512 512">
								<path fill="currentColor"
									d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512zm-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
							</svg>
						</template>
					</el-table-column>
				</el-table>
				<el-button @click="addRental" block type="primary" plain class="mt-3 w-100 primary">+ Add</el-button>
			</b-form>
		</ValidationObserver>
	</div>
</template>

<script>
import { Button, Form, FormItem, Table, TableColumn, Select, Option } from 'element-ui'
import { useCommonStore } from '@/stores/commonStore';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
// import '@/assets/js/formValidations.js'
import { mapActions } from 'pinia'
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	props: ['customer'],
	components: {
		CurrencyInput,
		ValidationObserver,
		ValidationProvider,
		[Button.name]: Button,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	computed: {
		rentals() {
			return _gHlp.getValue(this.customer,'incomes.rental',[]);
		},
		totalRentalIncome() {
			if (!_gHlp.isEmpty(this.rentals)) {
				const total = this.rentals.reduce((acc, rental) => {
					const amount = parseFloat(rental.amount);
					if (isNaN(amount)) {
						return acc;
					}
					return acc + amount;
				}, 0);
				return parseFloat(total.toFixed(2));
			}

			return 0.00;
		},
	},
	data() {
		return {
			tables: {},
		}
	},
	created() {
		this.getTablesLookup();

		gEventBus.$on('collect-income-data', this.sendIncomeData);
	},
	beforeDestroy() {
		gEventBus.$off('collect-income-data', this.sendIncomeData);
	},
	methods: {
		...mapActions(useCommonStore, ['getTables']),
		async getTablesLookup() {
			this.tables = await this.getTables('housing_types');
		},
		setData() {
			let rentals = _gHlp.isEmpty(this.rentals) ? [] : this.rentals.map((obj, index) => {
				return {
					...(obj.customer_rental_income_id && { customer_rental_income_id: obj.customer_rental_income_id }),
					amount: obj.amount,
					postcode: obj.postcode,
					housing_type_id: obj.housing_type_id,
					project_name: obj.project_name,
				}
			})

			let data = { rentals: rentals }
			return data;
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		},
		removeRental(item) {
			if (this.rentals.length > 0) {
				var index = this.rentals.indexOf(item);
				this.rentals.splice(index, 1);
			}
		},
		addRental() {
			this.rentals.push({
				amount: null,
				postcode: null,
				housing_type_id: null,
				project_name: null,
			});
		},
	}
}
</script>